import type { GridPosition } from '../types';

const compare = (a: GridPosition, b: GridPosition): number => {
  if (a.x < b.x) return -1;
  if (a.x > b.x) return 1;
  if (a.y < b.y) return -1;
  if (a.y > b.y) return 1;
  return 0;
};

/**
 * Sorts GridPositions with priority x -> x,y
 * @param positions
 */
export function sortGridPositions(positions: GridPosition[]): GridPosition[] {
  return positions.sort(compare);
}
